import React from 'react';

import PropTypes from 'prop-types';

//import ReactBootstrap from 'react-bootstrap';

import ReactDOM from 'react-dom/server';
import flush from 'styled-jsx/server';

//import ProgressBar from 'react-bootstrap/ProgressBar';

import Link from 'next/link';
import { Component } from 'react';
import dynamic from 'next/dynamic';

import ReactDOMServer from 'react-dom/server';

import _JSXStyle from 'styled-jsx/style';

import TemporaryDrawer from './Drawer_Component';

import { useContext, useState, useEffect } from 'react';
import { Context_UserInformation } from '../../Data/ContextProvider';

import ScoreComputations from './Score_Computations';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';



//import MyApp from '../../../pages/_app'


// This function is the main header shown at the top
export default function StatusBox() {

    return (

        <div className="mainBoxStatusBar">
            
        </div>
    );
}
